
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveBrokerPPrivatePolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionnaire"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PPrivateQuestionnaireInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"policyholder"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePersonSaveInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"riskQuestions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PPrivateRiskQuestionsSaveInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainExpiry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brokerDocumentDeliveryMethod"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentDeliveryMethod"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"policyholderDocumentDeliveryMethod"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentDeliveryMethod"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentInterval"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentInterval"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documents"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveBrokerPPrivatePolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"questionnaire"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionnaire"}}},{"kind":"Argument","name":{"kind":"Name","value":"policyholder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"policyholder"}}},{"kind":"Argument","name":{"kind":"Name","value":"riskQuestions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"riskQuestions"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainExpiry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainExpiry"}}},{"kind":"Argument","name":{"kind":"Name","value":"brokerDocumentDeliveryMethod"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brokerDocumentDeliveryMethod"}}},{"kind":"Argument","name":{"kind":"Name","value":"policyholderDocumentDeliveryMethod"},"value":{"kind":"Variable","name":{"kind":"Name","value":"policyholderDocumentDeliveryMethod"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentInterval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentInterval"}}},{"kind":"Argument","name":{"kind":"Name","value":"documents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documents"}}},{"kind":"Argument","name":{"kind":"Name","value":"offerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validationErrors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":874}};
    doc.loc.source = {"body":"mutation SaveBrokerPPrivatePolicy(\n  $questionnaire: PPrivateQuestionnaireInput!\n  $policyholder: CreatePersonSaveInput!\n  $riskQuestions: PPrivateRiskQuestionsSaveInput!\n  $mainExpiry: String\n  $brokerDocumentDeliveryMethod: DocumentDeliveryMethod\n  $policyholderDocumentDeliveryMethod: DocumentDeliveryMethod\n  $paymentInterval: PaymentInterval\n  $documents: [String!]\n  $offerId: Int\n) {\n  saveBrokerPPrivatePolicy(\n    questionnaire: $questionnaire\n    policyholder: $policyholder\n    riskQuestions: $riskQuestions\n    mainExpiry: $mainExpiry\n    brokerDocumentDeliveryMethod: $brokerDocumentDeliveryMethod\n    policyholderDocumentDeliveryMethod: $policyholderDocumentDeliveryMethod\n    paymentInterval: $paymentInterval\n    documents: $documents\n    offerId: $offerId\n  ) {\n    success\n    offerId\n    validationErrors {\n      field\n      key\n      message\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["SaveBrokerPPrivatePolicy"] = oneQuery(doc, "SaveBrokerPPrivatePolicy");
        
